/** Single site logo used in header, favicon, and default social previews */
export const SITE_LOGO_PATH = '/images/logo_white.png';
export const SITE_LOGO_URL = 'https://nightfallshop.com/images/logo_white.png';
